// Copyright © Veeam Software Group GmbH

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { malachite } from '@veeam/components/themes';

import { ResourcesContextProvider } from 'infrastructure/resources';
import { ErrorManager } from 'infrastructure/error-management/ErrorContextProvider';
import { LoginPage } from 'pages/LoginPage';
import { Main } from 'components/MainLayout';
import { Router } from 'infrastructure/routing';

export const App: React.FC = () => (
    <ThemeProvider theme={malachite}>
        <ResourcesContextProvider>
            <LoginPage>
                <ErrorManager>
                    <Router>
                        <Main />
                    </Router>
                </ErrorManager>
            </LoginPage>
        </ResourcesContextProvider>
    </ThemeProvider>
);
